import Checkbox from '@eversports/react-components/primitives/Checkbox'
import Flex from '@eversports/react-components/primitives/Flex'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { SelectAddOnField } from '../../../typings/AdditionalInformation'

const MultiSelectionField: React.FC<React.PropsWithChildren<SelectAddOnField>> = ({ id, description, options }) => (
  <Flex flexDirection="column" fullWidth>
    <Text>{description}</Text>
    {options.map((option) => (
      <Checkbox
        key={option.id}
        name={id}
        value={option.id}
        label={
          option.price ? (
            <>
              {option.description} (
              <MonetaryValue value={option.price.value} currencyCode={option.price.currency} />)
            </>
          ) : (
            option.description
          )
        }
      />
    ))}
  </Flex>
)

export default MultiSelectionField
